import React, { useState } from "react";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import { Ticket } from "../../../models/Ticket";
import getId from "../../../../utils/getId";
import { HiOutlineTicket } from "react-icons/hi";
import HtmlTooltip from "@mui/material/Tooltip";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  passesList: Ticket[];
  loading: boolean;
  joinToExercise: (value: boolean, passId: string) => void;
  reservationList: boolean;
  exerciseStart: number;
}

const ExerciseInfoPassSelectorReservationList: React.FC<IProps> = ({
  passesList,
  loading,
  joinToExercise,
  exerciseStart,
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const getFilteredPassesList = () => {
    const filteredPassesList = passesList.filter(
      (item) => item.validfrom <= exerciseStart && exerciseStart <= item.validto
    );
    return filteredPassesList;
  };

  const handleClickInOption = (value: boolean, id: string) => {
    joinToExercise(value, id);
    setShowOptions(false);
  };

  return (
    <LoadableComponent loading={loading}>
      {passesList.length > 1 ? (
        <>
          {showOptions ? (
            <div className="custom-select">
              <HtmlTooltip
                placement="top"
                title={
                  <>
                    <article
                      className="tooltip-description"
                      dangerouslySetInnerHTML={{
                        __html:
                          "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie.",
                      }}
                    ></article>
                  </>
                }
              >
                <EAButton
                  title="Lista rezerwowa"
                  onClick={() => setShowOptions(false)}
                  endIcon={<IoIosArrowDown />}
                  variant="outlined"
                />
              </HtmlTooltip>

              <ul className="options-list shadow">
                {getFilteredPassesList().map((option) => (
                  <>
                    {option.ticket === false && (
                      <li
                        className="flex-between-center"
                        key={getId(option)}
                        onClick={() => handleClickInOption(false, getId(option))}
                      >
                        <div className="flex-start-center">
                          <HiOutlineTicket className="icon" /> {option.name}
                        </div>

                        {option.entrances - option.exercises.length <= 0 && (
                          <div className="alert-red alert alert-small">Wyczerpano</div>
                        )}
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </div>
          ) : (
            <HtmlTooltip
              placement="top"
              title={
                <>
                  <article
                    className="tooltip-description"
                    dangerouslySetInnerHTML={{
                      __html:
                        "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie.",
                    }}
                  ></article>
                </>
              }
            >
              <EAButton
                title="Lista rezerwowa"
                onClick={() => setShowOptions(true)}
                endIcon={<IoIosArrowUp />}
                variant="outlined"
              />
            </HtmlTooltip>
          )}
        </>
      ) : (
        <HtmlTooltip
          placement="top"
          title={
            <>
              <article
                className="tooltip-description"
                dangerouslySetInnerHTML={{
                  __html:
                    "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie.",
                }}
              ></article>
            </>
          }
        >
          <EAButton
            title="Lista rezerwowa"
            onClick={() => joinToExercise(false, "null")}
            endIcon={<AiOutlineUserAdd />}
            variant="outlined"
          />
        </HtmlTooltip>
      )}
    </LoadableComponent>
  );
};

export default ExerciseInfoPassSelectorReservationList;
